<template>
<!-- モーダルナビ -->
<div id="c-gnav" class="c-gnav">
  <transition name="fade">
  <div v-if="isOpen" id="c-gnav__modal" class="c-gnav__modal">
    <nav class="c-menu">
      <a class="c-menu__logo" href="/"></a>
      <div class="c-menu__link c-menu__link--1">
        <ul>
          <li><a href="/?anchor=screen">上映スケジュール</a></li>
          <li><a href="/movie/">特集・作品紹介</a></li>
          <li><a href="/information/event/">注目のイベント</a></li>
          <li><a href="/information/news/">お知らせ</a></li>
          <li><a href="/theater/?anchor=access">アクセス</a></li>
        </ul>
      </div>
      <div class="c-menu__link c-menu__link--2">
        <ul>
          <li><a class="is-logo" href="/magazine/">STRANGET MAGAZINE</a></li>
          <li><a href="/magazine/feature/">Features</a></li>
        </ul>
      </div>
      <div class="c-menu__link c-menu__link--3">
        <ul>
          <li><a href="/theater/">劇場案内</a></li>
          <li><a href="/supporters/">支援者のみなさま</a></li>
          <li><a href="/privacy-policy/">個人情報保護方針</a></li>
        </ul>
        <a class="c-btnWhite c-btnWhite--external" href="https://strangelove2022.square.site/" target="_blank">
          <span class="is-logo-store">STRANGER ONLINE STORE</span>
        </a>
      </div>
      <!-- SNS -->
      <div class="c-menu__sns">
        <div class="c-footerSns c-footerSns--cinema">
          <div class="is-title">
            <img :src="`${assets_path}img/common/logo-cinema-w@2x.png`" alt="STRANGER CINEMA THEQUE" width="263" height="76" />
          </div>
          <div class="is-sns">
            <ul>
              <li>
                <a class="c-iconTw c-iconTw--w" href="https://twitter.com/strangelove2022" target="_blank" title="twitter"></a>
              </li>
              <li>
                <a class="c-iconInsta c-iconInsta--w" href="https://www.instagram.com/stranger.tokyo/" target="_blank" title="instagram"></a>
              </li>
              <li>
                <a class="c-iconFb c-iconFb--w" href="https://www.facebook.com/stranger.tokyo" target="_blank" title="facebook"></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="c-footerSns c-footerSns--cafe">
          <div class="is-title">
            <img :src="`${assets_path}img/common/logo-cafe-w@2x.png`" alt="STRANGER CAFE" width="223" height="85" />
          </div>
          <div class="is-sns">
            <ul>
              <li>
                <a class="c-iconTw c-iconTw--w" href="https://twitter.com/strangercafebar" target="_blank" title="twitter"></a>
              </li>
              <li>
                <a class="c-iconInsta c-iconInsta--w" href="https://www.instagram.com/stranger.cafebar/" target="_blank" title="instagram"></a>
              </li>
              <li>
                <a class="c-iconFb c-iconFb--w" href="https://www.facebook.com/stranger.cafebar" target="_blank" title="facebook"></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="c-footerSns c-footerSns--magazine">
          <div class="is-title">
            <img :src="`${assets_path}img/common/logo-magazine-w@2x.png`" alt="STRANGER MAGAZINE" width="234" height="85" />
          </div>
          <div class="is-sns">
            <ul>
              <li>
                <a class="c-iconTw c-iconTw--w" href="https://twitter.com/Strangermgzn" target="_blank" title="twitter"></a>
              </li>
              <li>
                <a class="c-iconInsta c-iconInsta--w" href="https://www.instagram.com/stranger.cinemagazine/" target="_blank" title="instagram"></a>
              </li>
              <li>
                <a class="c-iconFb c-iconFb--w" href="https://www.facebook.com/stranger.cinemagazine" target="_blank" title="facebook"></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 閉じる -->
      <div class="c-menu__close" @click="toggle"><span></span></div>
    </nav>
  </div>
  </transition>

  <!-- ボタン -->
  <div id="c-trigger" class="c-trigger" @click="toggle">
    <div class="c-trigger__open">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="c-trigger__close">
      <span></span>
    </div>
  </div>
</div>
</template>

<script>
  import {breakpoint, assets_path} from '@/_constant/variables';
  import store from '@/_modules/stores';
  //import 'intersection-observer';

  export default {
    data() {
      return {
        isOpen: false,
        breakpoint: breakpoint,
        assets_path: assets_path,
      }
    },
    store,
    computed: {
    },
    mounted() {
      this.$nextTick(this.init);
    },
    methods: {
      init() {
        if (location.pathname.indexOf('/magazine') > -1) {
          document.getElementById('c-header').querySelector('.c-header__logo').href = '/magazine/';
        }
      },
      toggle() {
        if (this.isOpen) {
          this.isOpen = false;
          window.gSTRG.rootHTML.classList.remove('is-gnav--modal-open');
        } else {
          this.isOpen = true;
          window.gSTRG.rootHTML.classList.add('is-gnav--modal-open');
        }
      }
    }
  }
</script>
